export default __webpack_public_path__ + "static/media/Star.b8be1a41.svg";